<template lang="pug">
  md-card
    md-card-header(data-background-color='green')
      h4.title Edit Profile
      p.category Complete your profile
    md-card-content
      div(v-if="!editActive")
        .md-layout
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label First Name
              md-input(v-model='user.first_name' type='text' disabled)
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Last Name
              md-input(v-model='user.last_name' type='text' disabled)
          .md-layout-item.md-small-size-100.md-size-100
            md-field
              label Email Address
              md-input(v-model='user.email' type='email' disabled)
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Major
              md-input(v-model='user.major' type='text' disabled)
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Gender
              md-input(v-if="user.gender != 'no'" :value="user.gender[0].toUpperCase() + user.gender.slice(1)" type='text' disabled)
              md-input(v-else value="Not specified" type='text' disabled)
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Graduation Year
              md-input(v-model='user.grad_year' type='text' disabled)
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Hometown
              md-input(v-model='user.hometown' type='text' disabled)
          .md-layout-item.md-small-size-100.md-size-50
            p(style="color: gray") Current Resume <br>
            md-icon insert_drive_file
            | <i v-if="user.resume_name"> {{user.resume_name}} </i>
            | <i v-else>None</i>

        md-button.md-raised.md-success(@click="editActive = true" style="float:right") Edit Profile
      div(v-else)
        .md-layout
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label First Name
              md-input(v-model='userEdit.first_name' type='text')
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Last Name
              md-input(v-model='userEdit.last_name' type='text')
          .md-layout-item.md-small-size-100.md-size-100
            md-field
              label Email Address
              md-input(v-model='userEdit.email' type='email')
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Major
              md-input(v-model='userEdit.major' type='text')
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Gender
              md-select(v-model='userEdit.gender')
                md-option(value='female') Female
                md-option(value='male') Male
                md-option(value='other') Other
                md-option(value='no') Prefer not to say
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Graduation Year
              md-select(v-model='userEdit.grad_year')
                md-option(value='2023') 2023
                md-option(value='2024') 2024
                md-option(value='2025') 2025
                md-option(value='2026') 2026
                md-option(value='2027') 2027
                md-option(value='2028') 2028
                md-option(value='2029') 2029
                md-option(value='2030') 2030
          .md-layout-item.md-small-size-100.md-size-50
            md-field
              label Hometown
              md-input(v-model='userEdit.hometown' type='text')
          .md-layout-item.md-small-size-100.md-size-50
            p(style="color: gray") Upload Resume (PDF only) <br>
            input(type="file" ref="resumeFile" accept=".pdf")
        h6(v-if="error" style="color: red; float: right;") Sorry, there was an error, please try again!
        md-button.md-raised.md-success(@click="updateProfile()" style="float: right") Update
        md-button(@click="clearEdit()" style="float: right;") Cancel
</template>

<script>
import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: "edit-profile-form",
  data() {
    return {
      user: null,
      userEdit: null,
      editActive: null,
      error: null,
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.user = this.$store.state.user;
      this.userEdit = cloneDeep(this.user);
      this.editActive = false;
    },
    updateProfile() {
      var formData = new FormData();
      let resume = this.$refs.resumeFile.files[0];
      if (resume) {
        this.userEdit.resume_name = resume.name;
      }
      for (var key in this.userEdit) {
        if (this.userEdit.hasOwnProperty(key)) {
          if(this.userEdit[key] !== null){
            formData.append(key, this.userEdit[key]);
          }
        }
      }
      formData.append('resume', resume);
      axios
      .post(
        `/api/members/${this.user.id}/upload`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then((response) => {
        this.$store.commit('updateUser', response.data);
        this.setup();
      }).catch((error) => {
        this.error = true;
      });
    },
    clearEdit() {
      this.userEdit = cloneDeep(this.user);
      this.editActive = false;
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/pages/UserManagement/EditProfileForm.vue